<template>
  <div>
    <slot></slot>
    <div id="contain-head"></div>
    <div id="top-contain">
      <div class="top-total">
        <span><a :class="classArray[0]" @click="order(0, orderEmon.NORMAL)">推荐</a></span>
        <span><a :class="classArray[1]" @click="order(1, orderEmon.SALENUM)">销量</a></span>
        <span><a :class="classArray[2]" @click="order(2, orderEmon.CHAOZHI)">超值</a></span>
        <span><a :class="classArray[3]" @click="order(3)">价格<span><img :src="imgArray" :class="arrayClass"/></span></a></span>
        <span :class="filterClass" @click="filter">筛选</span>
        <v-filter v-show="public.filterBody" :resert="public.resert"></v-filter>
      </div>
    </div>
  </div>
</template>
<script>
  import Filter from './Filter.vue'
  export default {
    name:'top',
    data(){
      return {
        imgArray:require('../../static/img/arrow.png'),
        classArray:['active','','',''],
        filterClass:'top-filter',
        arrayClass:'price-asc',
        orderStyle:0,
        priceOrder:false,
        orderIndex:'&order='+this.orderEmon.NORMAL
      }
    },
    created(){
      this.public.orderParam='';
    },
    mounted(){
      var seft = this;
      this.watcher.$on('closeAndSearchFilter',function(isResert,close){
        seft.public.filterBody = false;
        if(typeof close=='undefined'){
          if(isResert){
            seft.filterClass ='top-filter';
          }else{
            seft.filterClass='top-filter-active';
          }
        }
      });
    },
    watch:{
      endParam:function(param){
        console.log("param:"+param);
      },
      'public.resert':function(resert){
        this.filterClass ='top-filter';
        this.order(0,this.orderEmon.NORMAL);
      }
    },
    components:{
      'v-filter':Filter
    },
    methods:{
      handleOrderClass(idx){
        this.classArray=this.classArray.map(function(item,index,arr){
          if(index==idx){
            return 'active';
          }else{
            return '';
          }
        });
        if(idx==3){
          this.imgArray=require('../../static/img/arrowred.png')
        }else{
          this.imgArray=require('../../static/img/arrow.png')
        }
      },
      handleOrderStyle(orderStyle) {
        if (typeof orderStyle != 'undefined') { // 其它排序
          this.orderStyle = orderStyle;
          this.arrayClass = 'price-asc';
        } else if (this.orderStyle == this.orderEmon.PRICEDESC) {
          this.orderStyle = this.orderEmon.PRICEASC;
          this.arrayClass = 'price-asc';
        } else if (this.orderStyle == this.orderEmon.PRICEASC) {
          this.orderStyle = this.orderEmon.PRICEDESC;
          this.arrayClass = 'price-desc';
        } else { // 默认价格排序
          this.orderStyle = this.orderEmon.PRICEASC;
          this.arrayClass = 'price-asc';
        }
      },
      sendParamToBody(desc){
        this.watcher.$emit('sendParam',this.endParam,desc);
      },
      order(idx,orderStyle){
        this.public.filterBody = false;
        this.handleOrderClass(idx);
        this.handleOrderStyle(orderStyle);
        this.orderIndex = 'order='+this.orderStyle;
        this.public.orderParam = this.orderIndex;
        this.public.pageNumParam = '';
        this.public.toggleReload();
      },
      filter(){
//        this.filterClass='top-filter-active';
//        console.log(this.filterClass);
        this.public.filterBody = !this.public.filterBody;
//        this.public.moveTo();
        this.public.toggleReload();
      }
    }
  }
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// Top.vue?6297a4e9